import React from "react"
import types from "prop-types"
import { FlagIcon } from "shared/icons"

const FormSubmissionFlagging = ({ flagCount }) => (
  <div className="flex">
    <FlagIcon className="lg:mb-1" ariaHidden />
    {flagCount}
  </div>
)

FormSubmissionFlagging.propTypes = {
  flagCount: types.number.isRequired,
}

export default FormSubmissionFlagging
